import { render } from "./TabInformationsPeople.vue?vue&type=template&id=0ea3bbfe&scoped=true"
import script from "./TabInformationsPeople.vue?vue&type=script&lang=js"
export * from "./TabInformationsPeople.vue?vue&type=script&lang=js"

import "./TabInformationsPeople.vue?vue&type=style&index=0&id=0ea3bbfe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea3bbfe"]])

export default __exports__